import React, { useState, useEffect } from 'react';
import { db } from '../../../firebase'; // Asegúrate de que el path a tu config de Firebase sea correcto
import { collection, getDocs, query, where } from 'firebase/firestore';

const AutoridadesSistema = ({ isOpen, onClose }) => {
  const [autoridades, setAutoridades] = useState([]);
  const [filtroBusqueda, setFiltroBusqueda] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchAutoridades();
    }
  }, [isOpen]);

  const fetchAutoridades = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, 'users'), where('role', 'in', ['Administrador', 'Moderador']));
      const querySnapshot = await getDocs(q);
      const autoridadesData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setAutoridades(autoridadesData.sort((a, b) => a.nombre.localeCompare(b.nombre)));
    } catch (err) {
      console.error('Error al cargar autoridades:', err);
    } finally {
      setLoading(false);
    }
  };

  const autoridadesFiltradas = autoridades.filter(user =>
    user.nombre.toLowerCase().includes(filtroBusqueda.toLowerCase()) ||
    user.email.toLowerCase().includes(filtroBusqueda.toLowerCase()) ||
    (user.carrera && user.carrera.toLowerCase().includes(filtroBusqueda.toLowerCase()))
  );

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gradient-to-b from-black/70 to-black/50 flex items-center justify-center z-50 transition-opacity duration-500 ease-in-out">
      <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-sm sm:max-w-lg md:max-w-3xl lg:max-w-5xl max-h-[85vh] overflow-y-auto transform transition-all duration-500 ease-in-out scale-95 sm:scale-100 opacity-100 p-0 animate-slide-up">
        <div className="p-6 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center sticky top-0 bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900 dark:text-white bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-purple-600">
            Autoridades del Sistema
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 dark:text-gray-300 hover:text-gray-700 dark:hover:text-white transition duration-300 text-2xl font-bold hover:scale-110 transform"
          >
            ✕
          </button>
        </div>
        <div className="p-6">
          <div className="relative mb-6">
            <input
              type="text"
              placeholder="Buscar por nombre, correo o carrera..."
              value={filtroBusqueda}
              onChange={(e) => setFiltroBusqueda(e.target.value)}
              className="w-full p-4 pl-12 border border-gray-300 dark:border-gray-600 rounded-xl bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-4 focus:ring-indigo-300 dark:focus:ring-indigo-500 transition duration-300 text-lg shadow-sm"
            />
            <svg className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
          {loading ? (
            <div className="flex justify-center items-center h-40">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-indigo-500"></div>
            </div>
          ) : (
            <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-h-[60vh] overflow-y-auto">
              {autoridadesFiltradas.map(user => (
                <li
                  key={user.id}
                  className={`p-4 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 ${
                    user.role === 'Administrador'
                      ? 'bg-gradient-to-br from-yellow-50 to-amber-100 dark:from-yellow-900/50 dark:to-amber-800/50 border border-yellow-300 dark:border-yellow-700'
                      : 'bg-gradient-to-br from-purple-50 to-indigo-100 dark:from-purple-900/50 dark:to-indigo-800/50 border border-purple-300 dark:border-purple-700'
                  }`}
                >
                  <div className="flex items-center gap-4">
                    <img
                      src={user.photoURL || 'https://via.placeholder.com/64'}
                      alt={user.nombre}
                      className="w-16 h-16 rounded-full object-cover border-2 border-gray-200 dark:border-gray-700 shadow-sm"
                    />
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 dark:text-white truncate">{user.nombre}</h3>
                      <p className={`text-sm font-medium ${
                        user.role === 'Administrador' ? 'text-yellow-600 dark:text-yellow-400' : 'text-purple-600 dark:text-purple-400'
                      }`}>
                        {user.role}
                      </p>
                    </div>
                  </div>
                  <div className="mt-3">
                    <p className="text-sm text-gray-600 dark:text-gray-300">
                      <strong>Correo:</strong> <a href={`mailto:${user.email}`} className="underline hover:text-indigo-500 transition duration-200">{user.email}</a>
                    </p>
                    {user.carrera && (
                      <p className="text-sm text-gray-600 dark:text-gray-300">
                        <strong>Carrera:</strong> {user.carrera}
                      </p>
                    )}
                    
                  </div>
                </li>
              ))}
              {autoridadesFiltradas.length === 0 && (
                <p className="col-span-full text-center text-gray-600 dark:text-gray-400 py-8 animate-pulse">
                  No se encontraron autoridades.
                </p>
              )}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default AutoridadesSistema;